import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FormField from '../FormField';
import Conditional from '@app/components/common/Conditional';

const NeighborhoodField = ({ showNeighborhood }) => {
  const neighborhoodLabel = useSelector(
    state => state?.dealer.neighborhoodLabel
  );
  const isNeighborhoodRequired = useSelector(
    state => state?.dealer.isNeighborhoodRequired
  );
  const isNeighborhoodEnabled = useSelector(
    state => state?.dealer.isNeighborhoodEnabled
  );

  return (
    <Conditional test={isNeighborhoodEnabled && showNeighborhood}>
      <FormField
        fieldId="neighborhood"
        required={isNeighborhoodRequired}
        label={neighborhoodLabel}
      />
    </Conditional>
  );
};

NeighborhoodField.propTypes = {
  showNeighborhood: PropTypes.bool
};

export default NeighborhoodField;
